export const GRAMMAR_SESSION_KINDS = ['lesson', 'workout', 'checkpoint'] as const;

export type GrammarSessionKindType = (typeof GRAMMAR_SESSION_KINDS)[number];
